import { BEGIN, COMMIT, REVERT } from 'redux-optimistic-ui';
import uuid from 'uuid';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

export type OptimisticId = string;

export type OptimisticUiMeta = {
	optimistic: {
		type: typeof BEGIN | typeof COMMIT | typeof REVERT;
		id: OptimisticId;
	};
	analyticsEvent?: UIAnalyticsEvent;
};

export type OptimisticUiMetaWithFlag = OptimisticUiMeta & {
	showGenericFlag: true;
};

export type OptimisticUiMetaWithDisabledFlag = OptimisticUiMeta & {
	showGenericFlag: false;
};

export const optimisticUiRevertFlagId = 'OPTIMISTIC_REVERT_FLAG';

export const beginOptimisticUiMeta = (): OptimisticUiMeta => ({
	optimistic: {
		type: BEGIN,
		id: uuid.v4(),
	},
});

export const commitOptimisticUiMeta = (optimisticId: OptimisticId): OptimisticUiMeta => ({
	optimistic: {
		type: COMMIT,
		id: optimisticId,
	},
});

export const revertOptimisticUiMeta = (optimisticId: OptimisticId): OptimisticUiMeta => ({
	optimistic: {
		type: REVERT,
		id: optimisticId,
	},
});

export const revertOptimisticUiWithFlagMeta = (
	optimisticId: OptimisticId,
): OptimisticUiMetaWithFlag => ({
	optimistic: {
		type: REVERT,
		id: optimisticId,
	},
	showGenericFlag: true,
});

export const revertOptimisticUiWithDisabledFlagMeta = (
	optimisticId: OptimisticId,
): OptimisticUiMetaWithDisabledFlag => ({
	optimistic: {
		type: REVERT,
		id: optimisticId,
	},
	showGenericFlag: false,
});
